import { render, staticRenderFns } from "./UserDetails.vue?vue&type=template&id=a31185d2&scoped=true"
import script from "./UserDetails.vue?vue&type=script&lang=ts"
export * from "./UserDetails.vue?vue&type=script&lang=ts"
import style0 from "./UserDetails.vue?vue&type=style&index=0&id=a31185d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31185d2",
  null
  
)

export default component.exports